import { I18nShape } from '@tribeplatform/react-components/i18n'

export enum NavbarStyle {
  DEFAULT = 'default',
  STACKED = 'stacked',
}

export const availableNavbarStylesFactory = (intl: I18nShape) => [
  {
    title: intl.$t({
      defaultMessage: 'Default',
      id: 'Generics.Default',
    }),
    value: NavbarStyle.DEFAULT,
  },
  {
    title: intl.$t({
      defaultMessage: 'Stacked',
      id: 'Navbar.Styles.Stacked',
    }),
    value: NavbarStyle.STACKED,
  },
]

export enum NavbarNavigationAction {
  OPEN_LINK = 'OPEN_LINK',
}

export type NavbarNavigationItem = {
  label: string
  action: NavbarNavigationAction
  link?: string
  openInNewWindow?: boolean
}

export enum NavbarControlType {
  BUTTON = 'BUTTON',
  ICON = 'ICON',
  AVATAR = 'AVATAR',
}

export enum NavbarControlAction {
  CREATE_ITEM = 'CREATE_ITEM',
  SHOW_NOTIFICATION = 'SHOW_NOTIFICATION',
  SHOW_MESSAGING = 'SHOW_MESSAGING',
  SHOW_PROFILE = 'SHOW_PROFILE',
  SIGNUP = 'SIGNUP',
  LOGIN = 'LOGIN',
}

export type NavbarControlItem = {
  type: NavbarControlType
  action: NavbarControlAction
  label: string
  icon?: string
  showLabel?: boolean
  mobilePlacement?: 'top' | 'bottom'
}

export const defaultNavbarControlItemsFactory: (
  intl: I18nShape,
) => NavbarControlItem[] = intl => [
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.SHOW_MESSAGING,
    label: intl.$t({
      defaultMessage: 'Show Messaging',
      id: 'Navbar.Controls.ShowMessaging',
    }),
    icon: 'chat',
    showLabel: null,
    mobilePlacement: 'bottom',
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.SHOW_NOTIFICATION,
    label: intl.$t({
      defaultMessage: 'Show Notification',
      id: 'Navbar.Controls.ShowNotification',
    }),
    icon: 'bell',
    showLabel: null,
    mobilePlacement: 'bottom',
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.CREATE_ITEM,
    label: intl.$t({
      defaultMessage: 'Create Post',
      id: 'Navbar.Controls.CreatePost',
    }),
    icon: 'plus',
    showLabel: false,
    mobilePlacement: 'bottom',
  },
  {
    type: NavbarControlType.AVATAR,
    action: NavbarControlAction.SHOW_PROFILE,
    label: intl.$t({
      defaultMessage: 'Show Profile',
      id: 'Navbar.Controls.ShowProfile',
    }),
    icon: null,
    showLabel: null,
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.LOGIN,
    label: intl.$t({
      defaultMessage: 'Log in',
      id: 'Generics.LogIn',
    }),
    icon: null,
    showLabel: true,
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.SIGNUP,
    label: intl.$t({
      defaultMessage: 'Sign up',
      id: 'Navbar.Controls.Signup',
    }),
    icon: null,
    showLabel: true,
  },
]

export const defaultBottomBarControlItemsFactory: (
  intl: I18nShape,
) => NavbarControlItem[] = intl => [
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.CREATE_ITEM,
    label: intl.$t({
      defaultMessage: 'Create Post',
      id: 'Navbar.Controls.CreatePost',
    }),
    icon: 'plus',
    showLabel: false,
    mobilePlacement: 'bottom',
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.SHOW_NOTIFICATION,
    label: intl.$t({
      defaultMessage: 'Show Notification',
      id: 'Navbar.Controls.ShowNotification',
    }),
    icon: 'bell',
    showLabel: null,
    mobilePlacement: 'bottom',
  },
  {
    type: NavbarControlType.BUTTON,
    action: NavbarControlAction.SHOW_MESSAGING,
    label: intl.$t({
      defaultMessage: 'Show Messaging',
      id: 'Navbar.Controls.ShowMessaging',
    }),
    icon: 'chat',
    showLabel: null,
    mobilePlacement: 'bottom',
  },
]
